/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BecomeAmbassadorBody } from '../models';
// @ts-ignore
import type { BecomeAmbassadorResponse } from '../models';
// @ts-ignore
import type { BookCASlotBody } from '../models';
// @ts-ignore
import type { CAAcceptBody } from '../models';
// @ts-ignore
import type { CAApplyBody } from '../models';
// @ts-ignore
import type { CAAvailabilityForCandidateResponse } from '../models';
// @ts-ignore
import type { CACallResponse } from '../models';
// @ts-ignore
import type { ChatMessageResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GenerateReferralMessageBody } from '../models';
// @ts-ignore
import type { GenerateReferralMessageResponse } from '../models';
// @ts-ignore
import type { GetCAAnnouncementsResponse } from '../models';
// @ts-ignore
import type { GetCAChatMessagesResponse } from '../models';
// @ts-ignore
import type { GetCACompletionCertificateResponse } from '../models';
// @ts-ignore
import type { GetCADashboardResponse } from '../models';
// @ts-ignore
import type { GetCAInvitationPreviewResponse } from '../models';
// @ts-ignore
import type { GetCAJoiningLetterResponse } from '../models';
// @ts-ignore
import type { GetCAOpenCohortResponse } from '../models';
// @ts-ignore
import type { GetCAPublicInfoResponse } from '../models';
// @ts-ignore
import type { GetCAReferredUsersResponse } from '../models';
// @ts-ignore
import type { GetCAStatsResponse } from '../models';
// @ts-ignore
import type { GetReferableCompetitionsResponse } from '../models';
// @ts-ignore
import type { GetReferableCoursesResponse } from '../models';
// @ts-ignore
import type { GetReferableJobsResponse } from '../models';
// @ts-ignore
import type { MarkAnnouncementsSeenResponse } from '../models';
// @ts-ignore
import type { SendCAChatMessageBody } from '../models';
// @ts-ignore
import type { SubmitReferralEmailInvitesBody } from '../models';
// @ts-ignore
import type { SubmitReferralEmailInvitesResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
/**
 * CaApiApi - axios parameter creator
 */
export const CaApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CAAcceptBody} cAAcceptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiAcceptInvitation: async (cAAcceptBody: CAAcceptBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cAAcceptBody' is not null or undefined
            assertParamExists('caApiAcceptInvitation', 'cAAcceptBody', cAAcceptBody)
            const localVarPath = `/campus-ambassador/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cAAcceptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CAApplyBody} cAApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiApplyToCohort: async (cAApplyBody: CAApplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cAApplyBody' is not null or undefined
            assertParamExists('caApiApplyToCohort', 'cAApplyBody', cAApplyBody)
            const localVarPath = `/campus-ambassador/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cAApplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {BookCASlotBody} bookCASlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiBookCaCallSlot: async (availabilityId: string, bookCASlotBody: BookCASlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('caApiBookCaCallSlot', 'availabilityId', availabilityId)
            // verify required parameter 'bookCASlotBody' is not null or undefined
            assertParamExists('caApiBookCaCallSlot', 'bookCASlotBody', bookCASlotBody)
            const localVarPath = `/campus-ambassador/call/availability/{availability_id}/book`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookCASlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiDownloadCaCompletionCertificate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/completion-certificate/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiDownloadCaJoiningLetter: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/joining-letter/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateReferralMessageBody} generateReferralMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGenerateReferralMessage: async (generateReferralMessageBody: GenerateReferralMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateReferralMessageBody' is not null or undefined
            assertParamExists('caApiGenerateReferralMessage', 'generateReferralMessageBody', generateReferralMessageBody)
            const localVarPath = `/referral/message-suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateReferralMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaCallAvailability: async (availabilityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('caApiGetCaCallAvailability', 'availabilityId', availabilityId)
            const localVarPath = `/campus-ambassador/call/availability/{availability_id}`
                .replace('{availability_id}', encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaCompletionCertificate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/completion-certificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaDashboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaJoiningLetter: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/joining-letter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaReferredUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/referred-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetMyAnnouncements: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetMyCaChatMessages: async (cursor?: string | null, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/chat/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetOpenCohort: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/open-cohort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetPublicCaInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/campus-ambassador/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableCompetitions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/referable-competitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableCourses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/referable-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CaApiGetReferableJobsJobTypeEnum} [jobType] 
         * @param {string | null} [location] 
         * @param {string | null} [search] 
         * @param {CaApiGetReferableJobsWorkModeEnum} [workMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableJobs: async (jobType?: CaApiGetReferableJobsJobTypeEnum, location?: string | null, search?: string | null, workMode?: CaApiGetReferableJobsWorkModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/referable-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobType !== undefined) {
                localVarQueryParameter['job_type'] = jobType;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (workMode !== undefined) {
                localVarQueryParameter['work_mode'] = workMode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BecomeAmbassadorBody} becomeAmbassadorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiJoinCaProgram: async (becomeAmbassadorBody: BecomeAmbassadorBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'becomeAmbassadorBody' is not null or undefined
            assertParamExists('caApiJoinCaProgram', 'becomeAmbassadorBody', becomeAmbassadorBody)
            const localVarPath = `/campus-ambassador/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(becomeAmbassadorBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiMarkMyAnnouncementsSeen: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/announcements/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiPreviewInvitation: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('caApiPreviewInvitation', 'token', token)
            const localVarPath = `/campus-ambassador/invitation-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiRequestCaCompletion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campus-ambassador/request-completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendCAChatMessageBody} sendCAChatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiSendCaChatMessage: async (sendCAChatMessageBody: SendCAChatMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendCAChatMessageBody' is not null or undefined
            assertParamExists('caApiSendCaChatMessage', 'sendCAChatMessageBody', sendCAChatMessageBody)
            const localVarPath = `/campus-ambassador/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCAChatMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitReferralEmailInvitesBody} submitReferralEmailInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiSubmitReferralEmailInvites: async (submitReferralEmailInvitesBody: SubmitReferralEmailInvitesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitReferralEmailInvitesBody' is not null or undefined
            assertParamExists('caApiSubmitReferralEmailInvites', 'submitReferralEmailInvitesBody', submitReferralEmailInvitesBody)
            const localVarPath = `/referral/email-invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitReferralEmailInvitesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaApiApi - functional programming interface
 */
export const CaApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CAAcceptBody} cAAcceptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiAcceptInvitation(cAAcceptBody: CAAcceptBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiAcceptInvitation(cAAcceptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiAcceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CAApplyBody} cAApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiApplyToCohort(cAApplyBody: CAApplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiApplyToCohort(cAApplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiApplyToCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {BookCASlotBody} bookCASlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiBookCaCallSlot(availabilityId: string, bookCASlotBody: BookCASlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiBookCaCallSlot(availabilityId, bookCASlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiBookCaCallSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiDownloadCaCompletionCertificate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiDownloadCaCompletionCertificate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiDownloadCaCompletionCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiDownloadCaJoiningLetter(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiDownloadCaJoiningLetter(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiDownloadCaJoiningLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateReferralMessageBody} generateReferralMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGenerateReferralMessage(generateReferralMessageBody: GenerateReferralMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReferralMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGenerateReferralMessage(generateReferralMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGenerateReferralMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaCallAvailability(availabilityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAAvailabilityForCandidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaCallAvailability(availabilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaCallAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaCompletionCertificate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCACompletionCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaCompletionCertificate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaCompletionCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaDashboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCADashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaJoiningLetter(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAJoiningLetterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaJoiningLetter(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaJoiningLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaReferredUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAReferredUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaReferredUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaReferredUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetCaStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetCaStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetCaStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetMyAnnouncements(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAAnnouncementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetMyAnnouncements(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetMyAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetMyCaChatMessages(cursor?: string | null, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAChatMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetMyCaChatMessages(cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetMyCaChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetOpenCohort(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAOpenCohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetOpenCohort(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetOpenCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetPublicCaInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAPublicInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetPublicCaInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetPublicCaInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetReferableCompetitions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferableCompetitionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetReferableCompetitions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetReferableCompetitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetReferableCourses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferableCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetReferableCourses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetReferableCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CaApiGetReferableJobsJobTypeEnum} [jobType] 
         * @param {string | null} [location] 
         * @param {string | null} [search] 
         * @param {CaApiGetReferableJobsWorkModeEnum} [workMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiGetReferableJobs(jobType?: CaApiGetReferableJobsJobTypeEnum, location?: string | null, search?: string | null, workMode?: CaApiGetReferableJobsWorkModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReferableJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiGetReferableJobs(jobType, location, search, workMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiGetReferableJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BecomeAmbassadorBody} becomeAmbassadorBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiJoinCaProgram(becomeAmbassadorBody: BecomeAmbassadorBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BecomeAmbassadorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiJoinCaProgram(becomeAmbassadorBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiJoinCaProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiMarkMyAnnouncementsSeen(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkAnnouncementsSeenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiMarkMyAnnouncementsSeen(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiMarkMyAnnouncementsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiPreviewInvitation(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAInvitationPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiPreviewInvitation(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiPreviewInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiRequestCaCompletion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiRequestCaCompletion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiRequestCaCompletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendCAChatMessageBody} sendCAChatMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiSendCaChatMessage(sendCAChatMessageBody: SendCAChatMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiSendCaChatMessage(sendCAChatMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiSendCaChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubmitReferralEmailInvitesBody} submitReferralEmailInvitesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caApiSubmitReferralEmailInvites(submitReferralEmailInvitesBody: SubmitReferralEmailInvitesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitReferralEmailInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caApiSubmitReferralEmailInvites(submitReferralEmailInvitesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaApiApi.caApiSubmitReferralEmailInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaApiApi - factory interface
 */
export const CaApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CaApiApiCaApiAcceptInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiAcceptInvitation(requestParameters: CaApiApiCaApiAcceptInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.caApiAcceptInvitation(requestParameters.cAAcceptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiApplyToCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiApplyToCohort(requestParameters: CaApiApiCaApiApplyToCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.caApiApplyToCohort(requestParameters.cAApplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiBookCaCallSlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiBookCaCallSlot(requestParameters: CaApiApiCaApiBookCaCallSlotRequest, options?: RawAxiosRequestConfig): AxiosPromise<CACallResponse> {
            return localVarFp.caApiBookCaCallSlot(requestParameters.availabilityId, requestParameters.bookCASlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiDownloadCaCompletionCertificate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiDownloadCaCompletionCertificate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiDownloadCaJoiningLetter(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.caApiDownloadCaJoiningLetter(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiGenerateReferralMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGenerateReferralMessage(requestParameters: CaApiApiCaApiGenerateReferralMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReferralMessageResponse> {
            return localVarFp.caApiGenerateReferralMessage(requestParameters.generateReferralMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiGetCaCallAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaCallAvailability(requestParameters: CaApiApiCaApiGetCaCallAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CAAvailabilityForCandidateResponse> {
            return localVarFp.caApiGetCaCallAvailability(requestParameters.availabilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaCompletionCertificate(options?: RawAxiosRequestConfig): AxiosPromise<GetCACompletionCertificateResponse> {
            return localVarFp.caApiGetCaCompletionCertificate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaDashboard(options?: RawAxiosRequestConfig): AxiosPromise<GetCADashboardResponse> {
            return localVarFp.caApiGetCaDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaJoiningLetter(options?: RawAxiosRequestConfig): AxiosPromise<GetCAJoiningLetterResponse> {
            return localVarFp.caApiGetCaJoiningLetter(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaReferredUsers(options?: RawAxiosRequestConfig): AxiosPromise<GetCAReferredUsersResponse> {
            return localVarFp.caApiGetCaReferredUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetCaStats(options?: RawAxiosRequestConfig): AxiosPromise<GetCAStatsResponse> {
            return localVarFp.caApiGetCaStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiGetMyAnnouncementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetMyAnnouncements(requestParameters: CaApiApiCaApiGetMyAnnouncementsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCAAnnouncementsResponse> {
            return localVarFp.caApiGetMyAnnouncements(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiGetMyCaChatMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetMyCaChatMessages(requestParameters: CaApiApiCaApiGetMyCaChatMessagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCAChatMessagesResponse> {
            return localVarFp.caApiGetMyCaChatMessages(requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetOpenCohort(options?: RawAxiosRequestConfig): AxiosPromise<GetCAOpenCohortResponse> {
            return localVarFp.caApiGetOpenCohort(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetPublicCaInfo(options?: RawAxiosRequestConfig): AxiosPromise<GetCAPublicInfoResponse> {
            return localVarFp.caApiGetPublicCaInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableCompetitions(options?: RawAxiosRequestConfig): AxiosPromise<GetReferableCompetitionsResponse> {
            return localVarFp.caApiGetReferableCompetitions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableCourses(options?: RawAxiosRequestConfig): AxiosPromise<GetReferableCoursesResponse> {
            return localVarFp.caApiGetReferableCourses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiGetReferableJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiGetReferableJobs(requestParameters: CaApiApiCaApiGetReferableJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetReferableJobsResponse> {
            return localVarFp.caApiGetReferableJobs(requestParameters.jobType, requestParameters.location, requestParameters.search, requestParameters.workMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiJoinCaProgramRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiJoinCaProgram(requestParameters: CaApiApiCaApiJoinCaProgramRequest, options?: RawAxiosRequestConfig): AxiosPromise<BecomeAmbassadorResponse> {
            return localVarFp.caApiJoinCaProgram(requestParameters.becomeAmbassadorBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiMarkMyAnnouncementsSeen(options?: RawAxiosRequestConfig): AxiosPromise<MarkAnnouncementsSeenResponse> {
            return localVarFp.caApiMarkMyAnnouncementsSeen(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiPreviewInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiPreviewInvitation(requestParameters: CaApiApiCaApiPreviewInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCAInvitationPreviewResponse> {
            return localVarFp.caApiPreviewInvitation(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiRequestCaCompletion(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.caApiRequestCaCompletion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiSendCaChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiSendCaChatMessage(requestParameters: CaApiApiCaApiSendCaChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageResponse> {
            return localVarFp.caApiSendCaChatMessage(requestParameters.sendCAChatMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaApiApiCaApiSubmitReferralEmailInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caApiSubmitReferralEmailInvites(requestParameters: CaApiApiCaApiSubmitReferralEmailInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmitReferralEmailInvitesResponse> {
            return localVarFp.caApiSubmitReferralEmailInvites(requestParameters.submitReferralEmailInvitesBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for caApiAcceptInvitation operation in CaApiApi.
 */
export interface CaApiApiCaApiAcceptInvitationRequest {
    readonly cAAcceptBody: CAAcceptBody
}

/**
 * Request parameters for caApiApplyToCohort operation in CaApiApi.
 */
export interface CaApiApiCaApiApplyToCohortRequest {
    readonly cAApplyBody: CAApplyBody
}

/**
 * Request parameters for caApiBookCaCallSlot operation in CaApiApi.
 */
export interface CaApiApiCaApiBookCaCallSlotRequest {
    readonly availabilityId: string

    readonly bookCASlotBody: BookCASlotBody
}

/**
 * Request parameters for caApiGenerateReferralMessage operation in CaApiApi.
 */
export interface CaApiApiCaApiGenerateReferralMessageRequest {
    readonly generateReferralMessageBody: GenerateReferralMessageBody
}

/**
 * Request parameters for caApiGetCaCallAvailability operation in CaApiApi.
 */
export interface CaApiApiCaApiGetCaCallAvailabilityRequest {
    readonly availabilityId: string
}

/**
 * Request parameters for caApiGetMyAnnouncements operation in CaApiApi.
 */
export interface CaApiApiCaApiGetMyAnnouncementsRequest {
    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for caApiGetMyCaChatMessages operation in CaApiApi.
 */
export interface CaApiApiCaApiGetMyCaChatMessagesRequest {
    readonly cursor?: string | null

    readonly pageSize?: number
}

/**
 * Request parameters for caApiGetReferableJobs operation in CaApiApi.
 */
export interface CaApiApiCaApiGetReferableJobsRequest {
    readonly jobType?: CaApiGetReferableJobsJobTypeEnum

    readonly location?: string | null

    readonly search?: string | null

    readonly workMode?: CaApiGetReferableJobsWorkModeEnum
}

/**
 * Request parameters for caApiJoinCaProgram operation in CaApiApi.
 */
export interface CaApiApiCaApiJoinCaProgramRequest {
    readonly becomeAmbassadorBody: BecomeAmbassadorBody
}

/**
 * Request parameters for caApiPreviewInvitation operation in CaApiApi.
 */
export interface CaApiApiCaApiPreviewInvitationRequest {
    readonly token: string
}

/**
 * Request parameters for caApiSendCaChatMessage operation in CaApiApi.
 */
export interface CaApiApiCaApiSendCaChatMessageRequest {
    readonly sendCAChatMessageBody: SendCAChatMessageBody
}

/**
 * Request parameters for caApiSubmitReferralEmailInvites operation in CaApiApi.
 */
export interface CaApiApiCaApiSubmitReferralEmailInvitesRequest {
    readonly submitReferralEmailInvitesBody: SubmitReferralEmailInvitesBody
}

/**
 * CaApiApi - object-oriented interface
 */
export class CaApiApi extends BaseAPI {
    /**
     * 
     * @param {CaApiApiCaApiAcceptInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiAcceptInvitation(requestParameters: CaApiApiCaApiAcceptInvitationRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiAcceptInvitation(requestParameters.cAAcceptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiApplyToCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiApplyToCohort(requestParameters: CaApiApiCaApiApplyToCohortRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiApplyToCohort(requestParameters.cAApplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiBookCaCallSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiBookCaCallSlot(requestParameters: CaApiApiCaApiBookCaCallSlotRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiBookCaCallSlot(requestParameters.availabilityId, requestParameters.bookCASlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiDownloadCaCompletionCertificate(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiDownloadCaCompletionCertificate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiDownloadCaJoiningLetter(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiDownloadCaJoiningLetter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiGenerateReferralMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGenerateReferralMessage(requestParameters: CaApiApiCaApiGenerateReferralMessageRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGenerateReferralMessage(requestParameters.generateReferralMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiGetCaCallAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaCallAvailability(requestParameters: CaApiApiCaApiGetCaCallAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaCallAvailability(requestParameters.availabilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaCompletionCertificate(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaCompletionCertificate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaDashboard(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaJoiningLetter(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaJoiningLetter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaReferredUsers(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaReferredUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetCaStats(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetCaStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiGetMyAnnouncementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetMyAnnouncements(requestParameters: CaApiApiCaApiGetMyAnnouncementsRequest = {}, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetMyAnnouncements(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiGetMyCaChatMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetMyCaChatMessages(requestParameters: CaApiApiCaApiGetMyCaChatMessagesRequest = {}, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetMyCaChatMessages(requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetOpenCohort(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetOpenCohort(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetPublicCaInfo(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetPublicCaInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetReferableCompetitions(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetReferableCompetitions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetReferableCourses(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetReferableCourses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiGetReferableJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiGetReferableJobs(requestParameters: CaApiApiCaApiGetReferableJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiGetReferableJobs(requestParameters.jobType, requestParameters.location, requestParameters.search, requestParameters.workMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiJoinCaProgramRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiJoinCaProgram(requestParameters: CaApiApiCaApiJoinCaProgramRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiJoinCaProgram(requestParameters.becomeAmbassadorBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiMarkMyAnnouncementsSeen(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiMarkMyAnnouncementsSeen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiPreviewInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiPreviewInvitation(requestParameters: CaApiApiCaApiPreviewInvitationRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiPreviewInvitation(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiRequestCaCompletion(options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiRequestCaCompletion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiSendCaChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiSendCaChatMessage(requestParameters: CaApiApiCaApiSendCaChatMessageRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiSendCaChatMessage(requestParameters.sendCAChatMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaApiApiCaApiSubmitReferralEmailInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public caApiSubmitReferralEmailInvites(requestParameters: CaApiApiCaApiSubmitReferralEmailInvitesRequest, options?: RawAxiosRequestConfig) {
        return CaApiApiFp(this.configuration).caApiSubmitReferralEmailInvites(requestParameters.submitReferralEmailInvitesBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CaApiGetReferableJobsJobTypeEnum = {
    FullTime: 'FullTime',
    PartTime: 'PartTime',
    Temporary: 'Temporary',
    Contract: 'Contract',
    Internship: 'Internship',
    Fresher: 'Fresher',
    Freelance: 'Freelance',
} as const;
export type CaApiGetReferableJobsJobTypeEnum = typeof CaApiGetReferableJobsJobTypeEnum[keyof typeof CaApiGetReferableJobsJobTypeEnum];
export const CaApiGetReferableJobsWorkModeEnum = {
    Remote: 'Remote',
    OnSite: 'OnSite',
    Hybrid: 'Hybrid',
} as const;
export type CaApiGetReferableJobsWorkModeEnum = typeof CaApiGetReferableJobsWorkModeEnum[keyof typeof CaApiGetReferableJobsWorkModeEnum];
